const cdAppSettings = {
  baseUrl: "",
  apiUrl: "/cloud-diagrams/api",
  avaCoreServiceUrl: "https://ava-core-service-135469130251.us-central1.run.app",
};

export default cdAppSettings;
